import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "@iw-shop/core//services/environment.service";
import {Observable} from "rxjs";
import {ApiContactsSetRequest, ApiContactsSetResponse} from "@api/contacts";

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
  }

  set(data: ApiContactsSetRequest['params']['data']): Observable<ApiContactsSetResponse> {
    const body: ApiContactsSetRequest = {
      id: 'setContact#INVALID_PARAMS',
      command: 'contacts/set',
      params: {
        data
      }
    };
    return this.http.post<ApiContactsSetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }
}
